import { getKeys } from './getKeys'

export const cernerTranslations = {
  PERMISSION_REQUIRED: 'Permission Required',
  PERMISSION_DESCRIPTION: 'You do not have permission to view Shared Care Records. Please speak to your system administrator.',
  INSUFFICIENT_CERNER_ROLE_DESCRIPTION: 'You do not have the required permissions to access the London Care Record. Please speak to your Admin.',
  SITE_CONFIGURATION_REQUIRED: 'Site Configuration Required',
  SITE_CONFIGURATION_DESCRIPTION: 'This site is not configured for Shared Care Record access. Please contact your administrator.',
  INACTIVE_SERVICE_USER: 'Inactive Service User',
  INACTIVE_SERVICE_USER_DESCRIPTION: 'This service user is inactive. Their health record cannot be accessed.',
  NHS_NUMBER_REQUIRED: 'NHS Number Required',
  COLLAPSE: 'Collapse',
  EXPAND: 'Expand',
  NHS_NUMBER_DESCRIPTION: 'This service user does not have an NHS number. Please update their profile before accessing their health record.',
}

export const cernerConstants = getKeys(cernerTranslations)